import { RoundHeader } from "./RoundHeader";
import { TransactionHeader } from "./TransactionHeader";
import { RoundAccordion } from "../RoundAccordion";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DonationsTransactions(_ref) {
  let {
    transactionHash,
    contributions = {},
    transactionAttestationsData
  } = _ref;
  const roundIds = Object.keys(contributions);
  const contributionsArray = Object.values(contributions).flat();
  const nRounds = roundIds.length;
  if (nRounds === 0) return null;
  const transactionChainId = contributions[roundIds[0]][0].chainId;
  const {
    transactionAttestations = [],
    isFetchingAttestations,
    refetch
  } = transactionAttestationsData;
  const lastAttestation = transactionAttestations[0];
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-6",
    children: [/*#__PURE__*/_jsx(TransactionHeader, {
      transactionHash: transactionHash,
      transactionChainId: transactionChainId,
      contributions: contributionsArray,
      attestationData: {
        attestation: lastAttestation,
        isFetchingAttestations,
        refetch
      }
    }), /*#__PURE__*/_jsx(RoundHeader, {}), roundIds.map(roundId => /*#__PURE__*/_jsx(RoundAccordion, {
      contributions: contributions[roundId]
    }, roundId))]
  });
}